import React, { useEffect, useState } from "react";
import { useSearch } from "../../Hooks";
import Loading from "../../../../Common/Loading";
import { useSelector } from "react-redux";
import { Spinner } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { renderCategoryRoute } from "../../../../Common/Function";

const Search = ({
  handleFilter,
  getValue,
  btnHandler,
  loading,
  filterDelete,
}) => {
  const { getCategory, data, loadingSearch } = useSearch();
  const { city_slug } = useParams();
  const location = useLocation();
  const categoryPath = location.pathname.split("/")[1];
  const { categories, cities } = useSelector(state => state);

  useEffect(() => {
    if (!categories) {
      getCategory();
    }
  }, []);
  const getValueFromArr = () => {
    let res = "همه مجموعه ها";
    categories.map(ele => {
      if (ele.id == getValue("category_id")) {
        res = ele.name;
      }
    });
    return res;
  };
  const renderCorrentCity = id => {
    let res = {};
    cities.map(city => {
      if (city.slug == id || city.id == id) {
        res = { ...city };
      }
    });
    return res;
  };
  const navigate = useNavigate();
  if (!categories) {
    return (
      <div className="new-box-shadow search-box">
        <Loading count={1} height={"70"} />
      </div>
    );
  }
  return (
    <div className="search-box " id="search-box-item">
      <div
        className="container"
        style={{
          height: "100%",
        }}
      >
        <div
          className="row"
          style={{
            height: "100%",
          }}
        >
          <div className="col-12 col-lg-2">
            <select
              onChange={({ target: { value } }) => {
                navigate(`${renderCategoryRoute(value)["route"]}/${city_slug}`);
              }}
              value={renderCategoryRoute(categoryPath)["id"]}
            >
              {categories &&
                categories.map(category => {
                  return (
                    <option value={category.id} key={category.id}>
                      {category.name}
                    </option>
                  );
                })}
              {/*  */}
            </select>
          </div>
          <div className="col-lg-3">
            <select
              onChange={({ target: { value } }) => {
                if (value) {
                  navigate(
                    `/${categoryPath}/${renderCorrentCity(value)["slug"]}`
                  );
                }
              }}
              value={renderCorrentCity(city_slug)["id"]}
            >
              {cities &&
                cities.map(city => {
                  return (
                    <option value={city.id} key={city.id}>
                      {city.name}
                    </option>
                  );
                })}
            </select>
          </div>
          <div className="col-lg-3">
            <input
              style={{
                backgroundColor: "transparent",
                borderColor: "transparent",
                height: "100%",
                color: "#959595",
              }}
              placeholder={getValueFromArr("category_id")}
              onChange={({ target: { value } }) => {
                if (value.length % 2 === 0) {
                  handleFilter("name", value);
                }
              }}
              defaultValue={getValue("name")}
            />
          </div>
          <div className="col-lg-4 p-0">
            <button
              onClick={btnHandler}
              style={{
                border: "none",
                backgroundColor: "transparent",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#E42A3F",
                color: "#fff",
                height: "100%",
                width: "100%",
                height: "100%",
                fontSize: "20px",
                color: "#fff",
              }}
              disabled={loading}
            >
              {loading ? (
                <Spinner
                  as="span"
                  animation="border"
                  size="lg"
                  role="status"
                  aria-hidden="true"
                />
              ) : (
                <>
                  <img
                    src={window.origin + "/WebSide/assets/images/zoom.png"}
                    alt="امتیاز"
                    style={{
                      width: "20px",
                      height: "20px",
                    }}
                  />
                  جست و جو
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Search;
